import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Box, Button } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import AuthUtil from 'utils/AuthUtil';

export default function Login() {
  const auth = useAuth();

  React.useEffect(() => {
    AuthUtil.clearStorage();
  }, []);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Button
        variant='contained'
        color='primary'
        onClick={() => auth.signinRedirect()}
      >
        {t('login.cta')}
      </Button>
    </Box>
  );
}
